var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadsideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0367 3.26034C13.2274 3.15589 13.4666 3.22286 13.5753 3.41115L20.7528 15.8429C20.9068 16.1096 20.7143 16.4429 20.4064 16.4429L16.8821 16.4429C16.7378 16.4429 16.6047 16.3652 16.5338 16.2396L10.3097 5.21622C10.2 5.0221 10.2703 4.77584 10.4658 4.66874L13.0367 3.26034Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37606 19.3325C2.19026 19.2196 2.12867 18.979 2.23738 18.7907L9.41486 6.35889C9.56882 6.09223 9.95372 6.09223 10.1077 6.35889L11.8698 9.41101C11.942 9.53596 11.9412 9.69007 11.8679 9.81433L5.43345 20.7163C5.32014 20.9083 5.07176 20.9706 4.88125 20.8548L2.37606 19.3325Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4477 20.4633C21.4428 20.6807 21.2652 20.8543 21.0478 20.8543L6.69283 20.8543C6.38491 20.8543 6.19246 20.521 6.34642 20.2543L8.10856 17.2022C8.1807 17.0773 8.31453 17.0009 8.4588 17.0022L21.1174 17.1236C21.3403 17.1258 21.5185 17.3097 21.5135 17.5326L21.4477 20.4633Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7969,
    cy: 5.31115,
    r: 0.597745,
    stroke: "white",
    strokeWidth: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.27204,
    cy: 18.5148,
    r: 0.597745,
    transform: "rotate(-120 4.27204 18.5148)",
    stroke: "white",
    strokeWidth: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.269,
    cy: 18.735,
    r: 0.597745,
    transform: "rotate(120 20.269 18.735)",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadsideIcon);
export default __webpack_public_path__ + "static/media/roadside_icon.459acebe677cb59a0a31b7ff26f090af.svg";
export { ForwardRef as ReactComponent };